import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'fleetoperate-driver-license-details',
  templateUrl: './driver-license-details.component.html',
  styleUrls: ['./driver-license-details.component.scss']
})
export class DriverLicenseDetailsComponent implements OnInit {

  @Input() group: FormGroup;
  
  constructor() { }

  ngOnInit() {
  }

}
